/**
 * Digital Portfolio
 */
$(document).on("ready", function () {
  $(document).on("change", "#future-path__path", function () {
    if ($(this).find(":selected").data("details")) {
      $("#future-path__details").removeClass("hidden");
    } else {
      if (!$("#future-path__details").hasClass("hidden")) $("#future-path__details").addClass("hidden");
    }
  });
  const forms = document.querySelectorAll('.fakeFrm'); // from submit eventlisstener logic
  document.addEventListener('submit', (e) => {
    if (e.target.matches('.fakeFrm')) {
      e.preventDefault();
      console.log('Dynamic form submitted');

      e.target.querySelector("#do_action").value = "save";
      var which = e.target.closest(".fakeBlock")?.id;
      var whichAjax=which;
      console.log({which});
      if (which == "Assessments" || which=="fw_Assessments") { which = "LearningStyles"; whichAjax = "fw_LearningStyles";  }
      else if (which == "FuturePath" || which== "future-path" || which=="fw_FuturePath") { which = "future-path"; whichAjax = 'fw_future_path'; }
      console.log({which});
      console.log({whichAjax});
      addWaiting();
      $.ajax({
        type: "POST",
        url: "/wp-admin/admin-ajax.php",
        data: 'action='+whichAjax+'&'+$(e.target).serialize(),
        dataType: "html",
        success: function (data) {
          $("#" + which + " .contents").html(data);
          removeWaiting();
        },
        error: function (data) {
          removeWaiting();
          console.log(data);
        },
      });
    }
  });
  $(document).on("click", ".fakeFrm .save", function (e) {
   // e.preventDefault();
    //form.requestSubmit();
    //console.log('Form submitted:', e.target.id);
    /*cookie check for page
    if (document.cookie.indexOf("fw-connector") === -1) {
      window.location = fullBase + "/build-career-plan/digital-portfolio/";
    }*/

    const formElement = $(this).closest('.fakeFrm')[0];

    // 3. Trigger requestSubmit on the raw DOM element
    if (formElement && typeof formElement.requestSubmit === 'function') {
        formElement.requestSubmit();
    } else if (formElement) {
        // Fallback for very old browsers (like IE11) where requestSubmit doesn't exist
        formElement.submit();
    }
    /*
    var $frm = $(this).closest(".fakeFrm");
    $frm.children("#do_action").val("save");
    var which = $(this).closest(".fakeBlock").attr("id");
    var whichAjax=which;
    console.log({which});
    if (which == "Assessments" || which=="fw_Assessments") { which = "LearningStyles"; whichAjax = "fw_LearningStyles";  }
    else if (which == "FuturePath" || which== "future-path" || which=="fw_FuturePath") { which = "future-path"; whichAjax = 'fw_future_path'; }
    console.log({which});
    console.log({whichAjax});
    addWaiting();
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: 'action='+whichAjax+'&'+$frm.serialize(),
      dataType: "html",
      success: function (data) {
        $("#" + which + " .contents").html(data);
        removeWaiting();
      },
      error: function (data) {
        removeWaiting();
        console.log(data);
      },
    });
    */
  });

//}); // from submit eventlisstener logic

  $(document).on("click", ".fakeBlock .edit", function (e) {
    e.preventDefault();
    /*if (document.cookie.indexOf("fw-connector") === -1) {
      window.location = fullBase + "/build-career-plan/digital-portfolio/";
    }*/
    var which = $(this).closest(".fakeBlock").attr("id");
    var whichAjax=which;
    if (which == "Assessments" ||which=="fw_Assessments") { which = "LearningStyles"; whichAjax = "fw_LearningStyles";  }
    else if (which == "FuturePath" || which== "future-path" || which=="fw_FuturePath" ) { which = "future-path"; whichAjax = 'fw_future_path'; }
    var vals = {
      action:whichAjax,
      do_action: "edit",
    };
    addWaiting();
    $.ajax({
      type: "POST",
      url: "/wp-admin/admin-ajax.php",
      data: vals,
      dataType: "html",
      success: function (data) {
        $("#" + which + " .contents").html(data);
        if (which == "future-path") {
          $("#future-path__path").select2({
            width: "75%",
            placeholder: "Choose…",
          });
        }
        removeWaiting();
      },
      error: function (data) {
        console.log(data);
      },
    });
  });
});
